import {
    FETCH_USER_BEGIN,
    FETCH_USER_SUCCESS,
    LOGOUT_USER_BEGIN,
    LOGOUT_USER_SUCCESS,
    FETCH_USER_ROLES_SUCCESS,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_BEGIN,
    UPDATE_USER_TO_INACTIVE_BEGIN,
    UPDATE_USER_TO_INACTIVE_SUCCESS
} from '../actions/userActions';

const initialState = {
    roles: [],
    error: null,
    errors: [],
    users: [],
    loading: false,
    userUpdated: false,
    isAuthenticated: false
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_USER_BEGIN:
            return {
                ...state,
                loading: true
            };

        case FETCH_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                isAuthenticated: true,
                ...action.payload.user
            };
        case  FETCH_USER_ROLES_SUCCESS: {
            return {
                ...state,
               users: action.payload.users
            }
        }
        case UPDATE_USER_BEGIN: {
            return {
                ...state,
                loading: true,
            }
        } case UPDATE_USER_SUCCESS: {
            return {
                ...state,
                loading: false,
            }
        }
        case UPDATE_USER_TO_INACTIVE_BEGIN: {
            return {
                ...state,
                loading: true,
            }
        } case UPDATE_USER_TO_INACTIVE_SUCCESS: {
            return {
                ...state,
                loading: false,
            }
        }
        case LOGOUT_USER_BEGIN:
            return {
                ...state,
                loading: true
            };

        case LOGOUT_USER_SUCCESS:
            return {
                ...initialState,
                loading: false
            };

        default:
            return state;
    }
}
